module.exports = __webpack_public_path__ + "static/hnvk-35920113b821865ccdc2ea9b292f3ae8.svg";